import React from "react";

const NXBook = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5 0.5H2.5C1.94772 0.5 1.5 0.947715 1.5 1.5V12.5C1.5 13.0523 1.94772 13.5 2.5 13.5H11.5C12.0523 13.5 12.5 13.0523 12.5 12.5V1.5C12.5 0.947715 12.0523 0.5 11.5 0.5Z"

        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 10.5H12.5"

        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.5 3H9.5"

        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.5 5.5H9.5"

        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.5 8H7.5"

        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default NXBook;
